export default __webpack_public_path__ + "static/media/operation001.a74f8d8e.png";